import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-facebook-page-insights-identity',
  templateUrl: './help-facebook-page-insights-identity.component.html'
})
export class HelpFacebookPageInsightsIdentityComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
